export enum EmailValidationContext {
    User = 0,
    Broker = 1,
    Renter = 2,
  }